var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useGetCurrentUserQuery, useGetModuleStudioLabelsQuery, useLoadSystemConfigurationsQuery, useSaveStudioLabelsMutation, } from "@/store/api";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
export default function Language() {
    var _this = this;
    var _a, _b, _c, _d, _e;
    var _f = useTranslation(["common", "Studio", "ModuleBuilder"]), t = _f.t, i18n = _f.i18n;
    var _g = useParams(), packageName = _g.packagesName, moduleName = _g.moduleName, type = _g.type;
    var _h = useLoadSystemConfigurationsQuery(null), systemData = _h.data, error = _h.error;
    var userPreferences = useGetCurrentUserQuery(null).data;
    var _j = useSaveStudioLabelsMutation(), saveStudioLabelMutation = _j[0], _k = _j[1], saveData = _k.data, tokenAccessError = _k.error;
    var systemConfig = (systemData === null || systemData === void 0 ? void 0 : systemData.data) || {};
    var navigate = useNavigate();
    var defaultLanguage = ((_a = systemConfig.languages) === null || _a === void 0 ? void 0 : _a.default) || "fr_FR" || "";
    var availableLocales = Object.entries(((_b = systemConfig.languages) === null || _b === void 0 ? void 0 : _b.installed) || {}).map(function (l) { return ({ value: l[0], text: l[1] }); });
    var _l = useState("frequently_used"), selectedLabelsType = _l[0], setSelectedLabelsType = _l[1];
    var languagePreference = (_d = (_c = userPreferences === null || userPreferences === void 0 ? void 0 : userPreferences.data) === null || _c === void 0 ? void 0 : _c.preferences) === null || _d === void 0 ? void 0 : _d.language;
    var _m = useState(languagePreference), selectedLocale = _m[0], setSelectedLocale = _m[1];
    var labels_datas = useGetModuleStudioLabelsQuery({
        moduleName: moduleName,
        label: selectedLabelsType,
        lang: selectedLocale,
    }).data;
    var _o = useState({}), labels = _o[0], setLabels = _o[1];
    useEffect(function () {
        var _a;
        setLabels((_a = labels_datas === null || labels_datas === void 0 ? void 0 : labels_datas.data) === null || _a === void 0 ? void 0 : _a.MOD);
    }, [labels_datas]);
    var _p = useState(false), showLoader = _p[0], setShowLoader = _p[1];
    var labels_choice = labels_datas && ((_e = labels_datas === null || labels_datas === void 0 ? void 0 : labels_datas.data) === null || _e === void 0 ? void 0 : _e.labels_choice); // Example choice options
    var saveLabels = function () { return __awaiter(_this, void 0, void 0, function () {
        var newLabels, result, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    newLabels = Object.entries(labels).map(function (_a) {
                        var key = _a[0], value = _a[1];
                        return [
                            "label_" + key,
                            value,
                        ];
                    });
                    return [4 /*yield*/, saveStudioLabelMutation({
                            moduleName: moduleName,
                            body: {
                                package: packageName,
                                lang: selectedLocale,
                                new_labels: newLabels,
                            },
                        }).unwrap()];
                case 1:
                    result = _a.sent();
                    toast.success("Language saved");
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    toast.error("Language not saved");
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var cancelField = function () {
        // Handle cancel field logic
        navigate("/modules/ModuleBuilder/".concat(type, "/packages/").concat(packageName, "/").concat(moduleName));
    };
    var changeHandler = function (event) {
        // Handle input change logic
        var _a = event.target, name = _a.name, value = _a.value;
        setLabels(function (prevLabels) {
            var _a;
            return (__assign(__assign({}, prevLabels), (_a = {}, _a[name] = value, _a)));
        });
    };
    return (_jsx("div", __assign({ className: " " }, { children: _jsxs("div", __assign({ className: "flex flex-col max-h-[50vh] overflow-y-scroll " }, { children: [_jsxs("div", __assign({ className: "flex flex-row" }, { children: [_jsx("button", __assign({ className: "button primary px-4 py-2 text-sm mr-2", onClick: saveLabels }, { children: t("LBL_BTN_SAVEPUBLISH", { ns: "Studio" }) })), _jsx("button", __assign({ className: "button primary px-4 py-2 text-sm mr-2", onClick: cancelField }, { children: t("LBL_BTN_CANCEL", { ns: "Studio" }) }))] })), _jsx("p", __assign({ className: "py-3" }, { children: _jsx("span", __assign({ className: "select select-sm" }, { children: _jsx("select", __assign({ value: selectedLabelsType, onChange: function (e) { return setSelectedLabelsType(e.target.value); }, className: " bg-white p-1 rounded-sm  text-sm border border-gray-400 mt-2 ", tabIndex: 1 }, { children: labels_choice &&
                                Object.entries(labels_choice).map(function (_a) {
                                    var key = _a[0], value = _a[1];
                                    return (_jsx("option", __assign({ value: key }, { children: value }), key));
                                }) })) })) })), _jsx("div", { className: "flex flex-col border  border-b-gray-200 mt-4" }), _jsxs("div", { children: [_jsx("div", { className: "flex flex-col" }), _jsxs("table", __assign({ className: "text-sm w-full" }, { children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", {}), _jsx("th", {})] }) }), _jsxs("tbody", __assign({ className: "text-gray-500 " }, { children: [_jsxs("tr", { children: [_jsx("td", { children: t("LBL_LANGUAGE", { ns: "ModuleBuilder" }) }), _jsx("td", __assign({ className: "flex items-end" }, { children: _jsx("p", __assign({ className: "control" }, { children: _jsx("span", __assign({ className: "select select-sm" }, { children: _jsx("select", __assign({ value: selectedLocale, onChange: function (e) { return setSelectedLocale(e.target.value); }, className: "bg-white p-1 rounded-sm  text-sm border border-gray-400 mt-2", tabIndex: 1 }, { children: availableLocales &&
                                                                    availableLocales.map(function (option, id) { return (_jsx("option", __assign({ value: option.value }, { children: option.text }), id)); }) })) })) })) }))] }), labels &&
                                            Object.entries(labels).map(function (_a) {
                                                var key = _a[0], value = _a[1];
                                                return (_jsxs("tr", __assign({ className: " border-t border-t-gray-200" }, { children: [_jsx("td", __assign({ className: " p-2" }, { children: key })), _jsx("td", { children: _jsx("input", { type: "text", name: key, value: value, onChange: changeHandler, className: "border border-gray-300 p-0.5 px-1" }) })] }), key));
                                            })] }))] }))] })] })) })));
}
